import api from './api';

const vendorInvoiceService = {
  // Get all vendor invoices
  getAllVendorInvoices: async (params = {}) => {
    try {
      const queryParams = new URLSearchParams();
      if (params.page) queryParams.append('page', params.page);
      if (params.limit) queryParams.append('limit', params.limit);
      if (params.paymentStatus) queryParams.append('paymentStatus', params.paymentStatus);
      if (params.supplier) queryParams.append('supplier', params.supplier);
      if (params.purchaseOrder) queryParams.append('purchaseOrder', params.purchaseOrder);
      if (params.search) queryParams.append('search', params.search);

      const queryString = queryParams.toString();
      const url = `/vendor-invoice${queryString ? `?${queryString}` : ''}`;
      
      const response = await api.get(url);
      return response.data;
    } catch (error) {
      console.error('Error fetching vendor invoices:', error);
      throw error;
    }
  },

  // Get vendor invoice by ID
  getVendorInvoiceById: async (id) => {
    try {
      const response = await api.get(`/vendor-invoice/${id}`);
      return response.data;
    } catch (error) {
      console.error('Error fetching vendor invoice:', error);
      throw error;
    }
  },

  // Get next invoice number
  getNextInvoiceNumber: async () => {
    try {
      const response = await api.get('/vendor-invoice/number/next');
      return response.data;
    } catch (error) {
      console.error('Error fetching next invoice number:', error);
      throw error;
    }
  },

  // Get source document (PO or GRN) for invoice creation
  getSourceDocumentForInvoice: async (type, id) => {
    try {
      const response = await api.get(`/vendor-invoice/source/${type}/${id}`);
      return response.data;
    } catch (error) {
      console.error('Error fetching source document for invoice:', error);
      throw error;
    }
  },

  // Create vendor invoice
  createVendorInvoice: async (invoiceData) => {
    try {
      const response = await api.post('/vendor-invoice', invoiceData);
      return response.data;
    } catch (error) {
      console.error('Error creating vendor invoice:', error);
      throw error;
    }
  },

  // Update vendor invoice
  updateVendorInvoice: async (id, invoiceData) => {
    try {
      const response = await api.put(`/vendor-invoice/${id}`, invoiceData);
      return response.data;
    } catch (error) {
      console.error('Error updating vendor invoice:', error);
      throw error;
    }
  },

  // Delete vendor invoice
  deleteVendorInvoice: async (id) => {
    try {
      const response = await api.delete(`/vendor-invoice/${id}`);
      return response.data;
    } catch (error) {
      console.error('Error deleting vendor invoice:', error);
      throw error;
    }
  },

  // Record payment
  recordPayment: async (id, paymentData) => {
    try {
      const response = await api.put(`/vendor-invoice/${id}/payment`, paymentData);
      return response.data;
    } catch (error) {
      console.error('Error recording payment:', error);
      throw error;
    }
  },

  // Get vendor invoice statistics
  getVendorInvoiceStats: async () => {
    try {
      const response = await api.get('/vendor-invoice/stats');
      return response.data;
    } catch (error) {
      console.error('Error fetching vendor invoice statistics:', error);
      throw error;
    }
  }
};

export default vendorInvoiceService;

